import React, { useReducer } from 'react'
import { GlobalContext } from './GlobalContext'

const win = window
const lang = win.lang  
const dir = lang === null || lang === 'ar' ? 'right' : 'left'
const rtl = lang === 'ar'

const initialState = {
  rtl: rtl,
  dir: dir,
  lang: lang,
  stepValue: 'one',
  profileUpdateScreen: 'MobileNumUpdate',
  //'MobileNumUpdate' 'ActivationCodeScreen' 'EmailAndCityUpdate' 'IDNumAndNationality' 'ActiveVoiceLines' 'AbsherOtp'
  userType: '',
  profileEnquiryResult: {},
  otpType: "",
  mobileNum: "", 
  serviceRequestID: "",
  email: "",
  hashCode: "",
  activeVoiceLines: [],
  orderId: ""
}

const reducer = (state, action) => {
  switch (action.type) {
    case 'GO_TO_SCREEN':
      return {
        ...state,
        profileUpdateScreen: action.payload.profileUpdateScreen,
      }
    case 'UPDATE_STEP_VALUE':
      return {
        ...state,
        stepValue: action.payload.stepVal,
      }
    case 'SET_PROFILE_ENQUIRY_RESULT_AND_USERTYPE':
      return {
        ...state,
        userType: action.payload.userType,
        mobileNum: action.payload.mobileNum,
        profileEnquiryResult: action.payload.profileEnquiryResult,
      }
    case 'UPDATE_MOBILE_NUM':
      return {
        ...state,
        mobileNum: action.payload.mobileNum,
        otpType: action.payload.otpType,
        hashCode: action.payload.hashCode,
      }
    case 'UPDATE_EMAIL_AND_CITY':
      return {
        ...state,
        email: action.payload.email,
        otpType: action.payload.otpType,
        hashCode: action.payload.hashCode,
      }
    case 'UPDATE_HASHCODE':
      return {
        ...state,
        hashCode: action.payload.hashCode,
      }
    // case 'UPDATE_ACTIVE_VOICE_LINES':
    //   return {
    //     ...state,
    //     activeVoiceLines: action.payload.activeVoiceLines,
    //   }
    case 'UPDATE_ACTIVE_VOICE_NUM':
      return {
        ...state,
        mobileNum: action.payload.mobileNum,
        otpType: action.payload.otpType,
        orderId: action.payload.orderId,
        serviceRequestID: action.payload.serviceRequestID
      }
    case 'UPDATE_ABSHER_OTP_TYPE':
      return {
        ...state,
        otpType: action.payload.otpType,
        orderId: action.payload.orderId,
        serviceRequestID: action.payload.serviceRequestID
      }
    default:
      return state
  }
}

export const GlobalProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <GlobalContext.Provider value={[state, dispatch]}>
      {props.children}
    </GlobalContext.Provider>
  );
};